import React from 'react';
import Icon from './Icon';

const MinusIcon = (props) => (
    <Icon {...props}>
        <path
            d="M5 12H19"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default MinusIcon;